import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Chấm công bằng GPS
export function chamCongGPS(params: any) {
  try {
    return axiosApi.post('/cham-cong/check-in/gps', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấm công bằng QR Code
export function chamCongQR(params: any) {
  try {
    return axiosApi.post('/cham-cong/check-in/qr', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấm công bằng Face Recognition
export function chamCongKhuonMat(params: { image: File | Blob; note?: string; locationId?: number }) {
  try {
    const formData = new FormData()
    formData.append('image', params.image, 'face_image.jpg')
    if (params.note) {
      formData.append('note', params.note)
    }
    if (params.locationId) {
      formData.append('locationId', params.locationId.toString())
    }
    return axiosApi.post('/cham-cong/check-in/khuon-mat', formData)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Đăng ký khuôn mặt (nhansu-ai qua backend)
export function dangKyKhuonMat(params: { image: File | Blob }) {
  try {
    const formData = new FormData()
    formData.append('image', params.image, 'face_enroll.jpg')
    return axiosApi.post('/cham-cong/check-in/dang-ky-khuon-mat', formData)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấm công bằng sinh trắc học thiết bị
export function chamCongSinhTracHoc(params: any) {
  try {
    return axiosApi.post('/cham-cong/check-in/sinh-trac-hoc', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấm công bằng mạng nội bộ
export function chamCongMangNoiBo(params: any) {
  try {
    return axiosApi.post('/cham-cong/check-in/mang-noi-bo', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấm công ra về
export function chamCongRaVe(params: any) {
  try {
    return axiosApi.post('/cham-cong/check-in/ra-ve', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch sử chấm công
export function layLichSuChamCong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/check-in/lich-su', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy trạng thái chấm công hôm nay
export function layTrangThaiHomNay(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/check-in/trang-thai-hom-nay', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy vị trí công ty
export function layViTriCongTy(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/check-in/vi-tri-cong-ty', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách mạng nội bộ
export function layDanhSachMangNoiBo(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/check-in/danh-sach-mang-noi-bo', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
